import PropTypes from 'prop-types';
import React from 'react';
import NavigationBase from './NavigationBase';
import classNames from 'classnames';

function Navigation(props) {
    let navigationClasses = classNames(props.className);

    return (
        <NavigationBase {...props} className={navigationClasses}/>
    );
}

Navigation.propTypes = {
    ...NavigationBase.propTypes,
    /** Adds divider line beneath the navigation */
    withBorder: PropTypes.bool,
    /** Left align. */
    leftAlign: PropTypes.bool,
};

Navigation.defaultProps = {
    ...NavigationBase.defaultProps,
    withBorder: false,
    leftAlign: true
};

export default Navigation; // eslint-disable-line new-cap